<p-table
  [value]="payments"
  [loading]="loading"
  [rowHover]="true"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">
  <ng-template pTemplate="header">
    <tr>
      <th>Mes / Año</th>
      <th>Cargo</th>
      <th>Crédito aplicado</th>
      <th>Saldo pendiente</th>
      <th>Estado</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-payment>
    <tr class="p-selectable-row">
      <td>{{ getMonthName(payment.chargeMonth, payment.chargeYear) }}</td>
      <td>{{ payment.charge | currency }}</td>
      <td>
        @if(payment.creditApplied > 0) {
          <span class="badge rounded-pill text-bg-info">{{ payment.creditApplied | currency }}</span>
        } @else {
          <span class="text-muted">—</span>
        }
      </td>
      <td>{{ payment.balance | currency }}</td>
      <td>
        @if(payment.status === true) {
          <span class="badge rounded-pill text-bg-success">Pagado</span>
        } @else if(payment.status === false) {
          <span class="badge rounded-pill text-bg-secondary">Validando</span>
        } @else {
          <span class="badge rounded-pill text-bg-danger">Sin pago</span>
        }
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="text-center text-muted py-4">
        <i class="material-icons d-block mb-1" style="font-size: 1.5rem; opacity: 0.4;">payments</i>
        <small>Sin historial de pagos</small>
      </td>
    </tr>
  </ng-template>
</p-table>
